import { render } from "./Spinup.vue?vue&type=template&id=6afcdb70&scoped=true"
import script from "./Spinup.vue?vue&type=script&lang=js"
export * from "./Spinup.vue?vue&type=script&lang=js"

import "./Spinup.vue?vue&type=style&index=0&id=6afcdb70&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afcdb70"]])

export default __exports__